module.exports = __webpack_public_path__ + "img/planet-earth.ffe9ee26.webp";